import { type CoordinationClientType } from '@atlassiansox/engagekit-ts';

import { getMonitoringClient } from '@confluence/monitoring';
import { Attribution } from '@confluence/error-boundary';

import { ENGAGEMENT_PLATFORM_MESSAGE_ID } from '../package-constants';

export const startMessage = async (client: CoordinationClientType) => {
	try {
		const isMessageActive = await client.start(ENGAGEMENT_PLATFORM_MESSAGE_ID);
		return isMessageActive;
	} catch (err) {
		getMonitoringClient().submitError(err, {
			attribution: Attribution.CONTENPLATES,
		});
	}
};

export const stopMessage = async (client: CoordinationClientType) => {
	try {
		await client.stop(ENGAGEMENT_PLATFORM_MESSAGE_ID);
	} catch (err) {
		getMonitoringClient().submitError(err, {
			attribution: Attribution.CONTENPLATES,
		});
	}
};
